/**
 * Presentation helpers for the Categories screens (Trioty redesign). Categories
 * have no colour/icon in the backend, so the tile colour is derived from a
 * stable hash of the id and mixed against the card surface to work in both
 * themes.
 */

const TILE_HUES = [
  "#2563EB",
  "#7C3AED",
  "#DC2626",
  "#15803D",
  "#0D9488",
  "#4D7C0F",
  "#B45309",
  "#C2410C",
  "#475569",
] as const;

export function categoryColorIndex(id: string): number {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

export function categoryTile(index: number): { bg: string; fg: string } {
  const fg = TILE_HUES[((index % TILE_HUES.length) + TILE_HUES.length) % TILE_HUES.length];
  return {
    fg,
    bg: `color-mix(in srgb, ${fg} 15%, var(--card))`,
  };
}

/** Share of the catalog this category holds (0–100, rounded). */
export function catalogShare(productCount: number, totalProducts: number): number {
  if (totalProducts <= 0) return 0;
  return Math.round((productCount / totalProducts) * 100);
}
